import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {BsFillEyeFill, BsFillEyeSlashFill} from "react-icons/bs";
import api from "../api/apiInterceptor";
import {logout} from "../redux-store/auth";
import {displayNotification} from "../redux-store/notification";
import {getUserInfo} from "../redux-store/selectors";
import ErrorIcon from "../images/errorIcon.png";
import {LENGTH_ERROR, MATCH_PASSWORD, REQUIRED_FIELD} from "../constants/Messages";


const ChangePassword = () => {
    const {handleSubmit, register,formState: {errors}, watch} = useForm()
    const dispatch = useDispatch();
    const userInfo = useSelector(getUserInfo)
    const [showPassword, setShowPassword] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [errorNewPassword, setErrorNewPassword] = useState("")
    const watchOldPassword = watch("newPassword1")
    const watchNewPassword = watch("newPassword2")
    const userName = !userInfo?.username ? userInfo?.principal.username : userInfo?.username

    const togglePassword = () => {
        setShowPassword(showPassword ? false : true)
    }

    useEffect(() => {
        setErrorMessage("")
    }, [watchOldPassword]);

    useEffect(() => {
        setErrorNewPassword("")
    }, [watchNewPassword]);

    const handleSubmitForm = async (data) => {
        try {
            await api.post(`/api/users/${userName}/pw`, data)
            dispatch(logout());
            dispatch(displayNotification({
                notificationStatus: "success",
                message: "Uspješno promijenjena lozinka",
                title: "Promjena lozinke"
            }))
        } catch (err) {
            if(err.response.data === "Password length must be at least 8 characters!"){
                setErrorMessage(LENGTH_ERROR)
            } else {
                setErrorNewPassword(MATCH_PASSWORD)
            }
        }
    }

    return (
        <>
            <div className="container position-absolute card-top top-50 start-50 translate-middle">
                <div className="row justify-content-sm-center">
                    <div className="col-12 col-sm-10 col-xl-6 col-lg-6 col-md-6 login-card">
                        <div className="card">
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(handleSubmitForm)}>
                                    <div className="pb-3 pt-3 text-center">
                                        <h3 className={"text-uppercase title-color"}>Promjena lozinke</h3>
                                    </div>
                                    <div className="pb-4 pt-3">
                                        <div className="mb-2 w-100">
                                            <label className="text-white login-label" htmlFor="password">Nova lozinka</label>
                                        </div>
                                        <div className="input-group mb-3">
                                            <input type={showPassword ? "text" : "password"}
                                                   className="form-control password-eye-input"
                                                   name={"newPassword1"}
                                                   {...register("newPassword1", {required: true})}/>
                                            <span className="input-group-text password-eye" id="basic-addon2" onClick={togglePassword}>{showPassword ? <BsFillEyeSlashFill/> :
                                                <BsFillEyeFill/>}</span>
                                        </div>
                                        {errors.newPassword1 && (
                                            <span className="loggin-error"><img src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                                        )}
                                    </div>
                                    <div className="pb-2 pt-4">
                                        <div className="mb-2 w-100">
                                            <label className="text-white login-label" htmlFor="password">Potvrda nove lozinke</label>
                                        </div>
                                        <div className="input-group mb-3">
                                            <input type={showPassword ? "text" : "password"}
                                                   className="form-control password-eye-input"
                                                   name={"newPassword2"}
                                                   {...register("newPassword2", {required: true})}/>
                                            <span className="input-group-text password-eye" id="basic-addon2" onClick={togglePassword}>{showPassword ? <BsFillEyeSlashFill/> :
                                                <BsFillEyeFill/>}</span>
                                        </div>
                                        {errors.newPassword2 && (
                                            <span className="loggin-error"><img src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                                        )}
                                    </div>
                                    {errorMessage && (
                                        <span className="loggin-error mr-2"><img
                                            src={ErrorIcon}/> {errorMessage}</span>
                                    )}
                                    {errorNewPassword && (
                                        <span className="loggin-error mr-2"><img
                                            src={ErrorIcon}/> {errorNewPassword}</span>
                                    )}
                                    <div className="d-flex align-items-center pt-3">
                                        <button type="submit" className="btn btn-main w-100">
                                            Sačuvaj
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangePassword;
